import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Home from "./Components/Home/Home";
import AboutUs from "./Components/AboutUs/AboutUs";
import ContactForm from "./Components/Contact/ContactForm";
import MiceVertical from "./Components/Mice Vertical/Mice";
import VisaList from "./Components/Visa/VisaList";
import PackageList from "./Components/Package/PackageList";
import Terms from "./Components/Policies/Terms";
import Privacy from "./Components/Policies/Privacy";
import Refund from "./Components/Policies/Refund";
import Events from "./Components/Events/Events";
import RnR from "./Components/RnR/RnR";
import Blog from './Components/Blog/Blog';
import SingleBlog from './Components/Blog/SingleBlog';

import VenuePlanner3D from "./Components/3DVenuePlanner/VenuePlanner3D";
import HotelDetails from "./Components/3DVenuePlanner/HotelGrid/HotelDetails";
import BallroomDetails from "./Components/3DVenuePlanner/BallroomGrid/BallroomDetails";

import LandingPage from "./Components/Package/MeghalayaPackage/LandingPage";
import CouplePackage from "./Components/Package/MeghalayaPackage/CouplePackage";
import FamilyPackage from "./Components/Package/MeghalayaPackage/FamilyPackage";

import Loader from "./Components/Loader/Loader";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Yaha tum apna actual API call ya assets load logic daal sakte ho
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // abhi demo ke liye 2 sec loader

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader loading={loading} />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="events" element={<Events />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="packages" element={<PackageList />} />
          <Route path="mice" element={<MiceVertical />} />
          <Route path="rnr" element={<RnR />} />
          <Route path="visa" element={<VisaList />} />
          <Route path="contact" element={<ContactForm />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund" element={<Refund />} />
       <Route path="venue-planner" element={<VenuePlanner3D />} />
          <Route path="/venue-planner/hotel/:hotelSlug"  element={<HotelDetails />}/>
          <Route
    path="/venue-planner/hotel/:hotelSlug/ballroom/:ballroomSlug"
    element={<BallroomDetails />}
/>


            <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:category/:blogId" element={<SingleBlog />} />
           <Route path="/meghalayatourpackage" element={<LandingPage />} />
          <Route path="/meghalayatourpackage/couple" element={<CouplePackage />} />
        <Route path="/meghalayatourpackage/family" element={<FamilyPackage />} />
 



        </Route>
      </Routes>
    </Router>
  );
}

export default App;
